import {getActiveExperiment} from '~/utils/middleware/getActiveExperiment'

export function getExperimentData({
  page,
  pageVariant,
  isDefaultVariant,
}: {
  page: string | undefined
  pageVariant?: string | undefined
  isDefaultVariant?: boolean
}) {
  if (!page) {
    return undefined
  }

  const pathname = page === '_homepage' ? '/' : `/${page}`
  const activeExperiment = getActiveExperiment(pathname)
  const experimentVariant = activeExperiment?.variants.find(variant =>
    isDefaultVariant ? variant.isDefaultVariant : variant.slug === pageVariant
  )

  if (!experimentVariant || !activeExperiment) {
    return undefined
  }

  return {
    experimentId: activeExperiment.experimentId,
    isDefaultVariant: experimentVariant.isDefaultVariant,
    experimentVariantWeight: experimentVariant.weight,
    pageVariant: experimentVariant.slug,
  }
}
